// extracted by mini-css-extract-plugin
module.exports = {"avatarCover":"LoadingsList_avatarCover__2ww8C"};